










































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import AppDecimalNumber from './AppDecimalNumber.vue'

export interface Column {
  label: string;
  field: string;
  sortable?: boolean;
  options: { label: string; value: string }[];
}

interface Sort {
  prop: string;
  order: 'ascending' | 'decending';
}

@Component({
  components: {
    AppDecimalNumber
  }
})
export default class TheDatatable extends Vue {
  @Prop() readonly loading!: boolean
  @Prop() readonly columns!: Array<Column>
  @Prop() readonly data!: Array<any>
  @Prop() readonly filters: Array<any>
  @Prop() readonly sort!: Sort
  @Prop() readonly search!: string
  @Prop({ default: true }) readonly show!: boolean
  @Prop({ default: false }) readonly redirect!: boolean
  @Prop() readonly selectionKey: string
  @Prop() readonly total: number
  private pageSizes = [10, 50, 100, 500, 1000]
  private pageSize = 10
  private currentPage = 1

  @Prop() clearSelection: boolean

  get pageSizesDisplay () {
    // return first size(10), if data total less than 10
    if (this.total < this.pageSizes[0]) return [this.pageSizes[0]]

    // get all the size that less than total
    const sizes = this.pageSizes.filter(size => size < this.total)

    // push last size
    const lastSize = (Math.round(this.total / 10) + 1) * 10
    sizes.push(lastSize)

    return sizes
  }

  get infoFrom () {
    if (this.currentPage !== 1) {
      return (this.currentPage - 1) * this.pageSize + 1
    } else {
      return this.data.length ? 1 : 0
    }
  }

  get infoTo () {
    return this.data.length < this.pageSize
      ? this.pageSize * (this.currentPage - 1) + this.data.length
      : this.pageSize * this.currentPage
  }

  get hasNoError () {
    return this.data.every(e => e.error === undefined)
  }

  pageChange (currentPage: number): void {
    this.currentPage = currentPage
    this.$emit('pageChangeCustom', this.currentPage)
  }

  rowClick (row: any): void {
    if (row.emit) this.$emit('rowClickCustom', row)
    if (!row.redirect) return
    window.location.href = row.redirect
  }

  handleSelection (rows: any[]) {
    this.$emit('selectionChange', rows)
  }

  handleCustomEvent (row) {
    this.$emit('customEventSelect', row)
  }

  tableRowClassName ({ row }) {
    if (row.error) {
      return 'warning-row'
    } else {
      return ''
    }
  }

  clearCheckboxOnHeader () {
    const appdatatable = this.$refs.appdatatable as any
    if (this.selectionKey && appdatatable) {
      appdatatable.clearSelection()
    }
  }

  handleSizeChange (val) {
    this.pageSize = val
    this.$emit('pageSizeChange', val)
  }

  mounted () {
    this.clearCheckboxOnHeader()
  }

  @Watch('clearSelection')
  clearSelectionCheckbox () {
    if (this.clearSelection) {
      this.clearCheckboxOnHeader()
    }
  }
}
